import { css } from 'lit';
import HTTPMethod from 'http-method-enum';
import { CustomMessageDto, InstantMessageDto } from '@typings/api';
import { ConfigDMSApi } from '@/config/ConfigDMS';
import { APIConfig } from '@/config/ConfigCARSx';
import APIRequest, { APIRequestReturn, getAPIHeaders } from '@/redux/APIRequest';

export const addInstantMessageToSigns = async (
	signIds: number[],
	message: InstantMessageDto,
): Promise<APIRequestReturn> => {
	const url = new URL(ConfigDMSApi.addInstantMessageToSigns(signIds), APIConfig.endpointURLBase);

	const apiRequestReturn = await APIRequest(
		new Request(url.href, {
			method: HTTPMethod.POST,
			headers: new Headers({
				...getAPIHeaders(),
			}),
			body: JSON.stringify(message),
		}),
		ConfigDMSApi.endpointTimeoutMs,
	);

	return apiRequestReturn;
};

export const saveCustomMessage = async (message: CustomMessageDto): Promise<APIRequestReturn> => {
	const url = new URL(ConfigDMSApi.CustomMessagesPostEndpoint, APIConfig.endpointURLBase);

	const apiRequestReturn = await APIRequest(
		new Request(url.href, {
			method: HTTPMethod.POST,
			headers: new Headers({
				...getAPIHeaders(),
			}),
			body: JSON.stringify(message),
		}),
		ConfigDMSApi.endpointTimeoutMs,
	);

	return apiRequestReturn;
};

export const resendSignMessage = async (signId: number): Promise<APIRequestReturn> => {
	const url = new URL(ConfigDMSApi.resendMessage(signId), APIConfig.endpointURLBase);

	const apiRequestReturn = await APIRequest(
		new Request(url.href, {
			method: HTTPMethod.GET,
			headers: new Headers({
				...getAPIHeaders(),
			}),
		}),
		ConfigDMSApi.endpointTimeoutMs,
		true,
		false,
	);

	return apiRequestReturn;
};

export default addInstantMessageToSigns;
